import React from 'react'
import { useTranslation } from 'react-i18next'
import { useStateContext } from '../context/StateContext'
import CTA from '../../../common/CTAButton/CTAButton'
import getChildStats from '../utils/functions'
import Graph from './Graph'
import ChildTable from './ChildTable'
import { componentEvent } from '../../../utils/tracking'
import arrowLeft from '../assets/svgs/arrow-left.svg'
import adults from '../assets/svgs/adults.svg'
import boy from '../assets/svgs/boy.svg'
import girl from '../assets/svgs/girl.svg'

export default function Results() {
  const [state, setState] = useStateContext()
  const { t } = useTranslation()
  const childStats = state.child
    ? getChildStats(state.bmi, state.gender, state.ageInMonths)
    : null

  function handleBack() {
    componentEvent('bmi-calculator', 'content', 'click', 'Back')

    setState(() => ({
      ...state,
      step: 'start',
      bmi: null,
      adult: false,
      child: false,
      gender: null,
      age: null,
      ageInMonths: null,
      height: null,
      weight: null,
    }))
  }

  const underweight = state.bmi < 18.5
  const healthy = state.bmi >= 18.5 && state.bmi <= 24.9
  const overweight = state.bmi >= 25.0 && state.bmi <= 29.9
  const obese = state.bmi >= 30.0

  const showAdultGraph =
    state.height >= 56 &&
    state.height <= 81 &&
    state.weight >= 77 &&
    state.weight <= 360
  const showChildGraph = state.bmi >= 10.0 && state.bmi <= 35.0

  return (
    <>
      <div className={`layout results ${state.adult ? 'adult' : 'child'}`}>
        {state.adult ? (
          <>
            <div className="layout__left">
              <div className="container">
                <div className="action">
                  <h3>{t('re-calc-adult')}</h3>
                  <CTA className="cta cta__arrow" onClick={() => handleBack()}>
                    <img src={arrowLeft} alt="" />
                  </CTA>
                </div>
                <img className="figure" src={adults} alt="" />
              </div>
            </div>
            <div className="layout__right">
              <div className="container">
                <p>{t('info-provided')}</p>
                <p className="bmi">{state.bmi}</p>
                {underweight ? <p>{t('underweight-result')}</p> : null}
                {healthy ? <p>{t('healthy-result')}</p> : null}
                {overweight ? <p>{t('overweight-result')}</p> : null}
                {obese ? <p>{t('obese-result')}</p> : null}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="layout__left">
              <div className="container">
                <p>{t('info-provided')}</p>
                <p className="bmi">{state.bmi.toFixed(1)}</p>
                <p>
                  {t('child-percentile')} {childStats.percentile}{' '}
                  {t('child-catagory')} {t(childStats.category)}
                </p>
                <p>
                  {t('ideal-bmi-child')}
                  {`${childStats.idealBMI.low.toFixed(1)} 
                  ${t('and')} ${childStats.idealBMI.high.toFixed(1)}`}
                </p>
              </div>
            </div>
            <div className="layout__right">
              <div className="container">
                <img
                  className="figure"
                  src={state.gender === 'm' ? boy : girl}
                  alt=""
                />
                <div className="action">
                  <h3>{t('re-calc-child')}</h3>
                  <CTA className="cta cta__arrow" onClick={() => handleBack()}>
                    <img src={arrowLeft} alt="" />
                  </CTA>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="layout__bottom">
        <div className="container">
          {state.adult ? (
            <div className="container">
              <h4>{t('advice-subtitle')}</h4>
              {underweight ? <p>{t('underweight-advice')}</p> : null}
              {healthy ? <p>{t('healthy-advice')}</p> : null}
              {overweight ? (
                <>
                  <p>{t('overweight-advice')}</p>
                  <p>{t('overweight-advice-cont')}</p>
                </>
              ) : null}
              {obese ? (
                <>
                  <p>{t('obese-advice')}</p>
                  <p>{t('obese-advice-cont')}</p>
                </>
              ) : null}
              {showAdultGraph && <Graph />}
              <p className="bmi-calculator__text">{t('fed-notice')}</p>
            </div>
          ) : (
            <div className="container">
              <h4>{t('advice-subtitle')}</h4>
              {childStats.category === 'Underweight' ? (
                <p>{t('underweight-advice-child')}</p>
              ) : null}
              {childStats.category === 'Healthy' ? (
                <p>{t('healthy-advice-child')}</p>
              ) : null}
              {childStats.category === 'Overweight' ? (
                <>
                  <p>{t('overweight-advice-child')}</p>
                  <p>{t('overweight-advice-cont-child')}</p>
                </>
              ) : null}
              {childStats.category === 'AtRisk' ? (
                <>
                  <p>{t('obese-advice-child')}</p>
                  <p>{t('obese-advice-cont-child')}</p>
                </>
              ) : null}
              <div className="blob">
                <ChildTable />
                {showChildGraph && <Graph />}
              </div>
              <p className="bmi-calculator__text">{t('child-warning')}</p>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
